import React from "react";
import { Navigate } from "react-router-dom";

import { SCROLL_TO_PRICING_STATE } from "../utils/scrollToPricing";

const Prices = () => (
  <Navigate to="/" replace state={SCROLL_TO_PRICING_STATE} />
);

export default Prices;
